module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 75.d27a06ee.png";